import util from "./util";

/**
 * Created by WangPing on 2019/7/25.
 */

/**
 * 初始化渲染插入数据
 * @param bridgeContext v3接口请求返回数据
 * @param campaignList  campaignList
 * @param campaignInfo  campaignList[0]
 * @param campaignInfo  campaign id 保存campaign信息
 */
export class Render {
    constructor(bridgeContext) {
        this.bridgeContext = bridgeContext;
        this.campaignList = this.bridgeContext.campaignList;
        this.campaignInfo = this.bridgeContext.campaignList[0];
        this.campaignMap = {}; //  campaign id 保存campaign信息
        this.adText(); // 广告文字根据系统语言切换
    }

    // 初始化campaignMap
    initCampaignMap() {
        for (let campaign of this.campaignList) {
            this.campaignMap = {
                [campaign.id]: campaign
            };
        }
    }

    // 插入点击跳转事件
    insertJumpUrl(cb) {
        /*document.querySelector('.container').addEventListener('click', function (e) {
            if(e.target.classList.contains('jumpUrl')){
                cb && cb();
            }
        },false)*/
        document.querySelector('.container').onclick = function (e) {
            if(e.currentTarget.classList.contains('jumpUrl')||e.target.classList.contains('jumpUrl')){
                cb && cb();
            }
        }
    }

    // 插入icon
    insertIcon(canClick) {
        const iconUrl = this.campaignInfo.icon_url;
        let iconArr = Array.from(document.getElementsByClassName("iconBox"));
        for (let i of Array.from(iconArr)) {
            if(canClick){
                i.innerHTML = `<img src="${iconUrl}" alt="" class="jumpUrl">`;
            }else{
                i.innerHTML = `<img src="${iconUrl}" alt="">`;
            }
        }
    }

    // 插入title
    insertTitle() {
        let titleArr = Array.from(document.getElementsByClassName("infoTitle"));
        for (let i of titleArr) {
            i.innerHTML = this.campaignInfo.title;
        }
    }

    // 插入banner图片
    insertImage() {
        let bannerArr = Array.from(document.getElementsByClassName("bannerBg"));
        let imageUrl = this.campaignInfo.image_url; //  图片url
        for (let i of bannerArr) {
            i.style.cssText += `background-image:url(${imageUrl});background-size:cover;`
        }
    }

    // 插入描述
    insertDes() {
        let descArr = Array.from(document.getElementsByClassName("infoDesc"));
        for (let i of descArr) {
            i.innerHTML = this.campaignInfo.desc;
        }
    }

    // 插入cta文字
    insertCta() {
        let ctaArr = Array.from(document.getElementsByClassName("cta"));
        for (let i of ctaArr) {
            i.innerHTML = this.campaignInfo.ctatext ? this.campaignInfo.ctatext : 'Install';
        }
    }

    //  获取星星评级
    getStar() {
        let rate = parseInt(this.campaignInfo.rating) ? parseFloat(this.campaignInfo.rating).toFixed(1) : parseFloat(5).toFixed(1);
        let fullStar = 0;
        let halfStar = 0;
        if (rate > 5 || rate < 1 || rate === 'undefined' || rate === 'null' || rate === '') {
            fullStar = 5;
            halfStar = 0;
        } else {
            fullStar = parseInt(rate);
            halfStar = Math.ceil((rate % 1) / 0.5);
        }
        let curStar = fullStar + 0.5 * halfStar;
        let starBoxArr = Array.from(document.getElementsByClassName("starBox"));
        for (let i of starBoxArr) {
            i.getElementsByTagName("span")[0].className = `star star-${curStar * 2}`;
        }
        // 插入星级评分数字
        const starNumberArr = Array.from(document.getElementsByClassName("starNumber"));
        if(starNumberArr&&starNumberArr.length>0){
            for (let i of starNumberArr) {
                i.innerHTML = rate;
            }
        }
    }

    //  插入隐私弹窗
    insertPrivacy() {
        const _this = this;
        try {
            if (util.device().isiOS) {
                _this.addPrivacy({
                    currentSDKVersion: _this.bridgeContext.sdk_info,
                });
            } else {
                util.getRewardJSContext(function (resRewardJsContext) {
                    _this.bridgeContext.sdk_info = resRewardJsContext && resRewardJsContext.sdk_info
                    _this.addPrivacy({
                        currentSDKVersion: _this.bridgeContext.sdk_info,
                    });
                });
            }

        } catch (e) {
            console.error(e)
        }
    }

    adText(){
        let text = navigator.language.indexOf('zh') > -1 ? '广告' : 'AD';
        document.getElementsByClassName("ad-text")[0].innerHTML = text;
    }

    //  广告标识图标显示判断
    handleFcb() {
        let val;
        if (util.device().isiOS) {
            val = this.campaignInfo.fcb;
        } else {
            if (this.campaignInfo.ad_tracking && this.campaignInfo.ad_tracking.fcb) {
                val = this.campaignInfo.ad_tracking.fcb;
            }
        }
        // 如果fcb为3则认为来源为广点通
        if (val === 3) {
            let gdt = document.getElementById('gdt');
            gdt.classList.remove('hide')
        } else if (/zh-CN/i.test(navigator.language)) {// 其他来源情况下, 默认只要系统语言为zh-CN(中国大陆), 就显示 mintegral 的角标
            let mtg = document.getElementById('mtg');
            mtg.classList.remove('hide')
        }
    }

    /**
     * 添加隐私政策图标和点击弹窗等交互
     * @param {object} 以下为可用的配置项
     * sdkContext [可选]对当前 SDK 调用 VideoBridge init 或 RewardJs getEndScreenInfo 时的返回值
     * sdkContext [可选] 左上角 icon 图标路径, 默认为 endv4 系模板的地址
     */
    addPrivacy({currentSDKVersion, iconPath = './static/assets/privacy-shadow.png'}) {
        // 在页面左上角添加 privacy icon
        let privacyIcon = document.createElement('a')
        privacyIcon.id = 'privacyIcon'
        privacyIcon.style.cssText = `position: fixed; top: 10px; left: 10px; background-image: url(data:image/png;base64,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); background-position: center; background-size: contain; z-index: 99999; display: inline-block; width: 20px; height: 20px;`
        document.body.appendChild(privacyIcon)
        // 点击 privacy icon 时, 拼接内容并展示隐私政策弹窗
        privacyIcon.addEventListener('click', function () {
            let privacyModalId = `privacyModalContainer`;

            // 如果弹窗实例已经创建, 则直接展示之前的弹窗, 不再走后续的初始化逻辑
            let isModalCreated = !!util.getEl(`#${privacyModalId}`)
            if (isModalCreated) {
                util.rmClass(util.getEl(`#${privacyModalId}`), 'hide')
                return
            }

            // 如果弹窗没有创建, 则初始化并创建弹窗
            let privacyContext = util.createPrivacyModal({privacyModalId})

            /**
             * 点击弹窗中的隐私政策链接时
             * 1. 如果当前版本为支持 openUrl 的新版本, 则通过外部浏览器打开官网的 privacy policy 页面
             * 2. 如果为老版本, 则在弹窗中切换展示模板自带的 privacy policy 内容
             * @param currentSDKVersion 当前 SDK 的版本
             */
            util.getEl(`#${privacyContext.privacyLinkId}`).addEventListener('click', function() {
                let privacyLink = privacyContext.modalConfig.privacyLink
                let canOpenUrl = util.isCurrentVersionGTE({
                    currentSDKVersion,
                    iosMin: `4.9.0`,
                    androidMin: `9.6.0`,
                })
                if (canOpenUrl) {
                    // 使用 SDK 提供的 openUrl 方法在外部浏览器打开
                    console.log('open privacy link in browser', {currentSDKVersion, canOpenUrl})
                    util.openUrl(privacyLink)
                } else {
                    // 不支持外部浏览器打开时, 使用纯 html 来显示 privacy policy
                    console.log('open privacy link in iframe', {currentSDKVersion, canOpenUrl})
                    util.addClass(util.getEl(`#${privacyContext.privacyIntroPageId}`), `hide`)
                    util.rmClass(util.getEl(`#${privacyContext.privacyDetailPageId}`), `hide`)
                    util.getEl(`#${privacyContext.privacyMainId}`).scrollTop = 0
                }
            })

            /**
             * 点击底部 ok 关闭按钮时关闭并重置弹窗状态
             */
            util.getEl(`#${privacyContext.privacyCloseButtonId}`).addEventListener('click', function () {
                util.getEl(`#${privacyContext.privacyMainId}`).scrollTop = 0
                util.addClass(util.getEl(`#${privacyContext.privacyModalId}`), 'hide')
                util.rmClass(util.getEl(`#${privacyContext.privacyIntroPageId}`), `hide`)
                util.addClass(util.getEl(`#${privacyContext.privacyDetailPageId}`), `hide`)
            })

            window.addEventListener('resize', function () {
                // 初始化弹窗按钮和内容区域高度
                let {ww, wh} = util.getWinWH()
                let privacyModalHeight = wh * 0.6
                let privacyCloseButtonHeight = Math.max(ww, wh) * 0.07
                let privacy = util.getEl(`#${privacyContext.privacyModalId}`)
                let privacyCloseButton = util.getEl(`#${privacyContext.privacyCloseButtonId}`)

                privacy && (privacy.style.height = wh * 0.6 + privacyCloseButtonHeight + 'px')
                privacyCloseButton && (privacyCloseButton.style.height = `${privacyCloseButtonHeight}px`)
            }, true)

        })
    }
}
/**
 * 滚动函数
 * @param elem 所有要滚动的元素的盒子
 * @param elemBox  所有要滚动最外层盒子，可见的高度
 * @param time  滚动时间
 */
export class Roll {
    constructor(options) {
        this.elem = options.elem;
        this.elemBox = options.elemBox;
        this.time = options.time;
        this.initRoll();
    }

    initRoll() {
        const elemBoxHeight = parseFloat(window.getComputedStyle(this.elemBox,null).height);
        const elemHeight = parseFloat(window.getComputedStyle(this.elem,null).height);
        let lineNum = 1;
        // 当取余之后大于5则向上取整，小于5向下取整，防止空行
        if((elemHeight%elemBoxHeight)>5){
            lineNum = Math.ceil(elemHeight / elemBoxHeight);
        }else{
            lineNum = Math.floor(elemHeight / elemBoxHeight);
        }
        let i = 0;  // 滚动的屏数
        let topV = 0; // 向上滚动的高度
        this.elem.style.cssText = "margin-top:0";
        if (lineNum > 1) { // 当行数大于等于1行时，开始滚动，否则不滚动
             window.rollTimer = setInterval(() => {
                i = i + 1;
                if (i > (lineNum - 1)) {
                    i = 0;
                    topV = 0;
                    this.elem.style.cssText = "margin-top:" + topV + "px";
                } else {
                    topV = -elemBoxHeight * i;
                    this.elem.style.cssText = "margin-top:" + topV + "px";
                }
            }, this.time);
        }
    }
}
/**
 * 自动storekit，即自动跳转，只限ios下主offer,需保证获取到campaign之后再跳转
 * @param params 接受任意参数对象
 */
export class AutoClick {
    constructor(params) {
        this.alac = util.getUrlParams('alac');// 自动点击参数获取
        // 用来标识当前模板是否需要开启 "自动storekit" 模块, endv4jump 包在 url 上没有 alac=1 时, 依然需要开启此功能
        this.allowAutoClick = (Number(this.alac) === 1) || util.getTemplateName() === 'endv4jump';
        this.params = params;   //  参数对象
    }
    //  初始化自动跳转逻辑
    initAutoClick(cb){
        // 如果 campaign.link_type 为1即自动跳转类型, 且是iOS, 则允许自动跳转逻辑继续，cb为跳转方法
        if (this.allowAutoClick && this.params.linkType === 1) {
            cb&&cb()
        }
    }
}
/**
 * 全屏可点
 */
export class FullScreenClick {
    constructor() {
        // 初始化 "全屏可点" 的模块开关, alecfc 为 1 时开启, 为 0 或其他任意值时关闭
        this.alecfc = util.getUrlParams('alecfc');
        // 用来标识当前模板是否需要开启 "全屏可点" 模块, endv4full 包在 url 上没有 alecfc=1 时, 依然需要开启此功能
        this.allowEndCardFullscreenClick = (Number(this.alecfc) === 1) || util.getTemplateName() === 'endv4full';
    }
    initFullScreenClick(cb){
        // 如果当前模板是 "全屏可点模板", 则更改点击 install 区域为全屏可点，cb 为点击跳转函数
        if (this.allowEndCardFullscreenClick) {
            console.log('当前模板交互类型: 全屏可点');
            document.getElementById('container').onclick = function (e) {
                cb && cb();
            }
        }
    }
}
